import { privateLambdaService } from './privateLambdaService';
import { api } from './api';
import authService from './authService';

export interface FigmaExtractResponse {
  status: string;
  message?: string;
  data: {
    projectId: string;
    figmaDesignUrl: string;
    fileName: string;
    colorPaletteCount: number;
    typographyStylesCount: number;
    s3Key: string;
    downloadUrl: string;
  };
}

export const figmaService = {
  /**
   * Extract Figma design data and store it for the project.
   * Called as a separate step after project creation when a Figma URL is present.
   * The backend reads figmaDesignUrl and figmaAccessToken from the project record.
   */
  extractDesign: async (projectId: string): Promise<FigmaExtractResponse> => {
    try {
      const token = authService.getToken();
      const authHeaders = token ? { 'X-Auth-Token': `Bearer ${token}` } : undefined;

      const result = await privateLambdaService.callPrivateLambdaApi(
        '/api/figma/extract',
        'POST',
        { projectId },
        authHeaders
      );
      return result;
    } catch (error) {
      console.error('Error extracting Figma design:', error);
      throw error;
    }
  },

  /**
   * Get the extracted Figma design text for a project
   */
  getDesignText: async (projectId: string): Promise<{ status: string; data: { designText: string } }> => {
    try {
      const token = authService.getToken();
      const authHeaders = token ? { 'X-Auth-Token': `Bearer ${token}` } : undefined;

      return await privateLambdaService.callPrivateLambdaApi(
        `/api/figma/${projectId}/text`,
        'GET',
        undefined,
        authHeaders
      );
    } catch (error) {
      console.error('Error fetching Figma design text:', error);
      throw error;
    }
  },
};

export default figmaService;
